// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m["default"] || m;
};
exports.components = {
  "component---src-pages-404-js": function componentSrcPages404Js() {
    return import("./../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */);
  },
  "component---src-pages-account-js": function componentSrcPagesAccountJs() {
    return import("./../../src/pages/account.js" /* webpackChunkName: "component---src-pages-account-js" */);
  },
  "component---src-pages-downloads-js": function componentSrcPagesDownloadsJs() {
    return import("./../../src/pages/downloads.js" /* webpackChunkName: "component---src-pages-downloads-js" */);
  },
  "component---src-pages-index-js": function componentSrcPagesIndexJs() {
    return import("./../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */);
  },
  "component---src-pages-invoice-js": function componentSrcPagesInvoiceJs() {
    return import("./../../src/pages/invoice.js" /* webpackChunkName: "component---src-pages-invoice-js" */);
  },
  "component---src-templates-wiki-page-js": function componentSrcTemplatesWikiPageJs() {
    return import("./../../src/templates/wiki-page.js" /* webpackChunkName: "component---src-templates-wiki-page-js" */);
  }
};